import React from "react";
import LegalShell from "@/pages/LegalShell";

export default function Terms() {
  return (
    <LegalShell eyebrow="LEGAL" title="Terms of Use" updated="February 2026">
      <h2>1. Acceptance of Terms</h2>
      <p>
        By accessing or using Qualmitta (the "Service"), operated by Qualmitta, you agree to be
        bound by these Terms of Use. If you do not agree, do not use the Service.
      </p>

      <h2>2. What Qualmitta Is (and Is Not)</h2>
      <p>
        Qualmitta is an AI-assisted drafting and research tool for medical device regulatory
        workflows. The Service helps you draft templates (510(k), PMA, De Novo, IFU, DHF, Risk
        Management, and similar), research FDA regulations, and analyze public FDA data
        (openFDA, MAUDE, eCFR).
      </p>
      <p>
        <strong>Qualmitta is not a law firm.</strong> Nothing produced by the Service is legal
        advice, regulatory advice, or a guarantee of clearance or approval by the U.S. Food and
        Drug Administration or any other regulatory authority. All output must be reviewed by
        qualified regulatory affairs professionals before use in a real submission.
      </p>

      <h2>3. Eligibility &amp; Account</h2>
      <p>
        You must be at least 18 years old and legally able to enter into this agreement. You
        agree to provide accurate information (including a working email address) and are
        responsible for activity on your account.
      </p>

      <h2>4. Acceptable Use</h2>
      <ul>
        <li>Do not use the Service to submit unlawful, harmful, or misleading content.</li>
        <li>Do not attempt to reverse-engineer, scrape at abusive rates, or attack the Service.</li>
        <li>Do not upload confidential third-party information you are not authorized to share.</li>
        <li>Do not represent Qualmitta output as being reviewed or approved by any regulatory body.</li>
      </ul>

      <h2>5. Content Ownership</h2>
      <p>
        You retain ownership of the inputs you provide and the outputs you generate. You grant
        Qualmitta a limited license to store and process those inputs and outputs solely to
        provide the Service to you.
      </p>

      <h2>6. AI Limitations</h2>
      <p>
        The Service uses large language models that can produce inaccurate, incomplete, or
        outdated information. Regulations change. Always verify citations, dates, and
        requirements against the current text on eCFR, FDA.gov, and other authoritative sources.
      </p>

      <h2>7. Third-Party Data</h2>
      <p>
        Qualmitta surfaces data from public sources including openFDA and eCFR. Those services
        are provided by the U.S. Government and are subject to their own terms of use and
        availability. Qualmitta does not warrant the completeness or timeliness of that data.
      </p>

      <h2>8. Patent &amp; IP Tools</h2>
      <p>
        Qualmitta's patent screening, Freedom-to-Operate (FTO) reports, and design-around
        suggestions are <strong>AI-assisted screening only</strong>. They are <strong>not</strong>
        a legal opinion, are <strong>not</strong> exhaustive, and cannot be relied on as a
        determination that a product does or does not infringe any patent. You must
        independently verify every patent citation on Google Patents or USPTO Patent Public
        Search and consult a registered patent attorney before any product, engineering,
        marketing, or commercial decision. Qualmitta accepts no liability for decisions made in
        reliance on its patent-related output.
      </p>

      <h2>9. Disclaimer of Warranties</h2>
      <p>
        THE SERVICE IS PROVIDED "AS IS" WITHOUT WARRANTIES OF ANY KIND, EXPRESS OR IMPLIED,
        INCLUDING WITHOUT LIMITATION WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
        PURPOSE, AND NON-INFRINGEMENT.
      </p>

      <h2>10. Limitation of Liability</h2>
      <p>
        TO THE MAXIMUM EXTENT PERMITTED BY LAW, QUALMITTA WILL NOT BE LIABLE FOR ANY INDIRECT,
        INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES, OR ANY LOSS OF PROFITS OR
        REVENUES, ARISING OUT OF YOUR USE OF THE SERVICE.
      </p>

      <h2>11. Termination</h2>
      <p>
        You may stop using the Service at any time. We may suspend or terminate access if you
        violate these Terms or if we discontinue the Service.
      </p>

      <h2>12. Changes</h2>
      <p>
        We may update these Terms from time to time. Continued use of the Service after changes
        constitutes acceptance of the updated Terms.
      </p>

      <h2>13. Contact</h2>
      <p>
        Questions about these Terms? Email <a href="mailto:hello@qualmitta.com">hello@qualmitta.com</a>.
      </p>
    </LegalShell>
  );
}
